/* file description */
import { ButtonLayout } from '@/asset/AssetTask/templates/Cascade/components';
import React, { useState } from 'react';
import { useButtonProps } from '../../effect/useButtonProps';
import { BtnInfoType } from '../../sp-business-btn';
import { WithContent } from './freshCamera';

interface PicImportProps {
  btnInfo: BtnInfoType;
}


export const PicImport: React.FC<PicImportProps> = ({ btnInfo }) => {
  const [visible, setVisible] = useState(false);

  const option = useButtonProps(btnInfo);

  const cutPic = async () => {
    setVisible(true);
  };

  return (
    <>
      <ButtonLayout
        {...option}
        onClick={cutPic}
      >{btnInfo.text}
      </ButtonLayout>
      <WithContent visible={visible} setVisible={setVisible} btnInfo={btnInfo} />
    </>
  );
};
